var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.biz)?_c('v-btn',{attrs:{"rounded":"","depressed":"","small":"","color":"#E4E6EB","loading":_vm.loading},on:{"click":function($event){return _vm.toggle()}}},[_c('v-icon',{attrs:{"small":"","left":"","color":_vm.color}},[_vm._v("mdi-heart")]),_c('span',[_vm._v(_vm._s(_vm.biz.stats.fav))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }